import { Component, ViewChild, Inject } from "@angular/core";
import { MatSidenav, MatDialog, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { Role, User } from "src/_models/user";
import { AuthenticationService } from "src/_services/authentication.service";
import { ChangePasswordModalComponent } from "../../pages/index";
import { AppService } from "src/_services/app.service";
import { UserService } from "src/_services/user.service";
import { Subscription } from "rxjs/internal/Subscription";
import { interval } from "rxjs";
import { roleTypeGroup,B2BUserMangUsers } from "src/_constants/roleType";
@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent {
  @ViewChild("sidenav") sidenav: MatSidenav;
  sub: Subscription;

  isExpanded = true;
  MainUsers = ["runmatrix"];
  SettlementUsers = ["runmatrix","guruops","adambo1","yogithbo1","harrybo1","freakbo1","tonybo1", "mikebo1", "rolexbo1", "roybo1", "sonubo1"];
  B2BUserMangUsers =  B2BUserMangUsers;
  NmUsers = ["nmsap"].concat(this.MainUsers); // for operator management, op-provider mang, partner mang, user mang
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  showSubGameMenu: boolean = false;
  showSurveillanceMenu: boolean = false;
  currentUser: User;
  balance: number = 0;
  title: string = "";
  roleTypeGroup = roleTypeGroup;

  reportsMenu: boolean = false;
  mtsMenu: boolean = false;
  surveillanceMenu: boolean = false;
  administrationMenu: boolean = false;
  userMenu: boolean = false;
  catalogMenu: boolean = false;
  invoiceMenu: boolean = false;

  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  public providers: any = JSON.parse(sessionStorage.getItem("category"));
  allowedRoles = ["RiskAdmin","SAPAdmin"]
  blockedRoles = ["VirtualUser","MetricsAdmin","InvoiceAdmin"]
  operators = ["99hub", "99exch", "laser247", "cric99", "21exch", "11xplay", "ramo247"]

  constructor(
    private authService: AuthenticationService,
    public router: Router,
    public dialog: MatDialog,
    private appService: AppService,
    private userService: UserService
  ) {
    this.authService.currentUser.subscribe((x) => (this.currentUser = x));
  }

  ngOnInit() {
    this.title = this.router.url.split("/")[1].toUpperCase();
    this.getBalance();
    const myNumber = interval(50000);
    myNumber.subscribe((number: number) => {
      this.getBalance();
    });
  }

  mtsMenuFunc(){
    if(this.mtsMenu){
      this.mtsMenu = false;
    }else{
      this.mtsMenu = true;
      this.reportsMenu = false;
      this.administrationMenu = false;
      this.surveillanceMenu = false;
      this.userMenu = false;
      this.catalogMenu = false;
      this.invoiceMenu = false;
    }
  }

  reportsMenuFunc(){
    if(this.reportsMenu){
      this.reportsMenu = false;
    }else{
      this.reportsMenu = true;
      this.administrationMenu = false;
      this.surveillanceMenu = false;
      this.userMenu = false;
      this.catalogMenu = false;
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }
  }

  surveillanceMenuFunc(){
    if(this.surveillanceMenu){
      this.surveillanceMenu = false;
    }else{
      this.surveillanceMenu = true;
      this.reportsMenu = false;
      this.administrationMenu = false;
      this.userMenu = false;
      this.catalogMenu = false;
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }
  }

  otherMenuFunc(){
    this.surveillanceMenu = false;
    this.reportsMenu = false;
    this.administrationMenu = false;
    this.userMenu = false;
    this.catalogMenu = false;
    this.invoiceMenu = false;
    this.mtsMenu = false;
  }

  expand() {
    this.isExpanded = !this.isExpanded;
    this.reportsMenu =false;
    this.administrationMenu = false;
    this.surveillanceMenu = false;
    this.invoiceMenu = false;
    this.mtsMenu = false;
    this.userMenu = false;
    this.catalogMenu = false;
  }

  administrationMenuFunc(){
    if(this.administrationMenu){
      this.administrationMenu = false;
    }else{
      this.administrationMenu = true;
      this.reportsMenu = false;
      this.surveillanceMenu = false;
      this.userMenu = false;
      this.catalogMenu = false;
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }
  }

  userMenuFunc(){
    if(this.userMenu){
      this.userMenu = false;
    }else{
      this.userMenu = true;
      this.catalogMenu = false;
      this.administrationMenu = false;
      this.reportsMenu = false;
      this.surveillanceMenu = false;
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }
  }

  catalogMenuFunc(){
    if(this.catalogMenu){
      this.catalogMenu = false;
    }else{
      this.catalogMenu = true;
      this.userMenu = false;
      this.administrationMenu = false;
      this.reportsMenu = false;
      this.surveillanceMenu = false;
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }
  }

  invoiceMenuFunc(){
    if(this.invoiceMenu){
      this.invoiceMenu = false;
      this.mtsMenu = false;
    }else{
      this.invoiceMenu = true;
      this.administrationMenu = false;
      this.userMenu = false;
      this.catalogMenu = false;
      this.reportsMenu = false;
      this.surveillanceMenu = false;
    }
  }

  dashboard() {
    if (this.title === "DASHBOARD2") {
      return true;
    } else {
      return false;
    }
  }

  reports() {
    if (this.title === "REPORTS") {
      return true;
    } else {
      return false;
    }
  }

  administration() {
    if (this.title === "ADMINISTRATION") {
      return true;
    } else {
      return false;
    }
  }

  mertics() {
    if (this.title === "SAP-METRICS") {
      return true;
    } else {
      return false;
    }
  }

  getBalance() {
    try {
      this.userService.getBalance().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.balance = res.balance;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  logout() {
    this.authService.logout();
    sessionStorage.clear();
    this.router.navigateByUrl("/login");
    window.location.reload();
  }

  handleChangePassword() {
    this.dialog.open(ChangePasswordModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { userId: this.userInfo.userId, page: "change-password" },
    });
  }

  goTo(link) {
    this.router.navigate([link]);
  }

  private readonly dashboardOperatorPrefix = "bc";

  private startsWithDashboardPrefix(operatorId: string): boolean {
    return (
      !!operatorId &&
      operatorId.toLowerCase().startsWith(this.dashboardOperatorPrefix)
    );
  }

  get showDashboardNav(): boolean {
    if (!this.currentUser || !this.userInfo) {
      return false;
    }
    if (this.blockedRoles.includes(this.userInfo.role)) {
      return false;
    }
    if (this.currentUser.role === Role.SAPAdmin) {
      return true;
    }
    if (this.currentUser.role === Role.OperatorAdmin) {
      return (
        this.startsWithDashboardPrefix(this.userInfo.operatorId) ||
        this.startsWithDashboardPrefix(this.currentUser.operatorId)
      );
    }
    if (this.currentUser.role === Role.GroupAdmin) {
      return (
        Array.isArray(this.userInfo.operators) &&
        this.userInfo.operators.some((op: string) =>
          this.startsWithDashboardPrefix(op)
        )
      );
    }
    return false;
  }

  goToDashboard() {
    if (!this.showDashboardNav) {
      return;
    }
    if (this.currentUser.role === Role.SAPAdmin) {
      this.goTo("/dashboard");
      return;
    }
    this.goTo("/operator-dashboard");
  }

  get isSAPAdmin() {
    return this.currentUser && this.currentUser.role === Role.SAPAdmin;
  }

  get isOperatorAdmin() {
    return (
      (this.currentUser && this.currentUser.role === Role.OperatorAdmin) ||
      this.currentUser.role === Role.OperatorUser
    );
  }

  get isGroupAdmin(){
    return (
      (this.currentUser && this.currentUser.role === Role.GroupAdmin) ||
      this.currentUser.role === Role.GroupAdmin
    )
  }

  get isValid() {
    if (this.currentUser && this.currentUser.role === Role.OperatorAdmin || this.currentUser.role === Role.OperatorUser) {
      if (this.providers && !this.providers.includes("Exchange")) {
        return false;
      }
    }
    return true;
  }

  get isMDAdmin() {
    if (this.currentUser && this.userInfo.role === "GroupAdmin") {
      if (this.operators.some(operator => this.userInfo.operators.includes(operator))) {
          return true;
      }
    }
    return false;
  }

  get isMainUser() {
      if (this.userInfo.role !== "SAPAdmin") {
        return true;
      }
    
      return this.MainUsers.includes(this.userInfo.userId);
  }

  get isMD() {
    if (this.currentUser && roleTypeGroup.includes(this.userInfo.role)) {
        if (this.operators.some(operator => this.userInfo.operators.includes(operator))) {
            return true;
        }
    } 
    // else if (this.currentUser && this.currentUser.role === Role.OperatorAdmin) {
    //     if (this.operators.includes(this.currentUser.operatorId)) {
    //         return true;
    //     }
    // }
    return false;
}

}
